import * as React from 'react';
import {TextArea, css, view} from '@sail/ui';
import {EXAMPLE_TEXT} from './common';

export const Size = () => (
  <view.div
    uses={[
      css({
        '& > *': {
          padding: css.value('8px 0'),
        },
      }),
    ]}
  >
    <TextArea
      label="Biography (large)"
      size="large"
      defaultValue={EXAMPLE_TEXT}
    />
    <TextArea
      label="Biography (medium, default)"
      size="medium"
      defaultValue={EXAMPLE_TEXT}
    />
    <TextArea
      label="Biography (small)"
      size="small"
      defaultValue={EXAMPLE_TEXT}
    />
  </view.div>
);
